/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Alexander Golshtein
 * @version 1.24.0
 * @since 1.24.0
 */

// Minimal count of items in select when need to show search input
export const ITEMS_MIN_COUNT_FOR_SEARCH_VISIBILITY = 10;
